import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';
import { UtilityDto, Client, UtilityCountry, UtilityStatusDataIn, UtilityStatus, FileParameter } from '../../../api/api-reference';
import { CronConverterComponent } from '../../../libraries/cron-converter/cron-converter.component';
import { TimeZoneService } from '../../../services/timezone.service';

@Component({
  selector: 'app-utility-setup',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    AngularSvgIconModule,
    RouterLink,
    FormsModule,
    CronConverterComponent,
  ],
  templateUrl: './utility-setup.component.html',
  styleUrl: './utility-setup.component.scss'
})
export class UtilitySetupComponent implements OnInit {
  data: UtilityDto = new UtilityDto(); //reminderDataOut
  utilityId: string = '';
  @ViewChild('fileInput') fileInput!: ElementRef;
  formData = new FormData();
  imagePreview: string | null = null;
  timezones = this.timezoneService.timezones;


  constructor(
    private toastr: ToastrService,
    public router: Router,
    public route: ActivatedRoute,
    private client: Client,
    private timezoneService:TimeZoneService
  ) {

  }

  ngOnInit(): void {
    const state = history.state;
    if (state && state.utilityData) {
      this.utilityId = state.utilityData;
    }

    if (this.utilityId)
      this.getUtility();
  }

  countryDictionary: UtilityCountry[] = Object.keys(UtilityCountry)
      .filter((key) => isNaN(Number(key)))
      .map((key) => UtilityCountry[key as keyof typeof UtilityCountry]);

  getUtility() {
    this.client.getUtility(this.utilityId).subscribe({
      next: (response : UtilityDto) => {
        this.data = response;
      },
      error: (err) => {
        this.toastr.error(err.message);
      },
    });
  }

  onSubmit() {
    if (this.utilityId == "" || this.utilityId == null) {
      this.addUtility()
    }
    else {
      this.editUtility();
    }
  }

  addUtility() {
    const { name, acronym, contactPersonEmail, contactPersonFirstName, contactPersonLastName, contactPersonPhoneNumber, 
      address, websiteAddress, country, timeZone} = this.data;

    const fileFromFormData = this.formData.get('file') as File | null;
    const fileParameter: FileParameter | undefined = fileFromFormData
      ? { data: fileFromFormData, fileName: fileFromFormData.name }
      : undefined;

    this.client.addUtility(name, acronym, contactPersonEmail, contactPersonFirstName, contactPersonLastName, contactPersonPhoneNumber, 
      address, websiteAddress ,country, timeZone,fileParameter).subscribe({
      next: (response) => {
        this.toastr.success(response);
        this.router.navigate(['/utilities/all']);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  editUtility() {
    const { id, name, acronym, contactPerson, address, websiteAddress, country, timeZone} = this.data;
    const fileFromFormData = this.formData.get('file') as File | null;
    const fileParameter: FileParameter | undefined = fileFromFormData
    ? { data: fileFromFormData, fileName: fileFromFormData.name }
    : undefined;

    this.client.editUtility(id, name, acronym, contactPerson, address, websiteAddress, country, timeZone,fileParameter).subscribe({
      next: (response) => {
        this.toastr.success(response);
        this.router.navigate(['/utilities/all']);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }


  onFileSelected(event: Event): void {
      const input = event.target as HTMLInputElement;
  
      if (input?.files?.length) {
        const file = input.files[0];
  
        if (
          file.type != 'image/png' &&
          file.type != 'image/jpg' &&
          file.type != 'image/jpeg'
        ) {
          this.toastr.error('Only PNG/JPG/JPEG images are allowed.');
        } else {
          const img = new Image();
          img.onload = () => {
            const width = img.width;
            const height = img.height;

            let ratio = width / height;
            if (ratio > 2 || ratio < 0.5) {
              this.toastr.warning('Unsuported image size.');
              return;
            }
            const allowedExtensions = ['png', 'jpg', 'jpeg'];
            const fileExtension = file.name.split('.').pop()?.toLowerCase();

            if (!allowedExtensions.includes(fileExtension!)) {
              this.toastr.error('Invalid file extension.');
              return;
            }
          };
          const file = input.files[0];
          this.formData.set('file', file, file.name);

          const reader = new FileReader();
          reader.onload = () => {
            this.data.logoPath = (reader.result as string).split(',')[1];
          };
          reader.readAsDataURL(file);
        }
        setTimeout(() => {
          input.value = '';
        }, 0);
    }
  }
}
